import { z } from "zod";

export const ProxyPoolProtocolSchema = z.union([
  z.literal("http"),
  z.literal("https"),
  z.literal("socks5"),
  z.literal("")
]);

export type ProxyPoolProtocolType = z.infer<typeof ProxyPoolProtocolSchema>;

type ProxyPoolProtocolOptionType = {
  value: ProxyPoolProtocolType;
  label: string;
}[];

export const proxyPoolProtocolOptions: ProxyPoolProtocolOptionType = [
  { value: 'http', label: 'HTTP' },
  {
    value: 'https',
    label: 'HTTPS',
  },
  { value: 'socks5', label: 'SOCKS5' },
];

export const proxyPoolProtocolOptionsMap = new Map<
ProxyPoolProtocolType,
  string
>(proxyPoolProtocolOptions.map((i) => [i.value, i.label]));